'use strict';
import { FooterBase } from './FooterBase';
import Render from './FooterRender';
import { connect } from 'react-redux';

class Footer extends FooterBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

// export default Footer
export default Footer = connect((state)=>{
    return {user:state.user || {}}
})(Footer);